import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import {
  MediumOutlineButton,
  MediumFilledButton,
  LoadingIcon
} from "components/Base";
import { noop, isEmptyOrNil } from "utils/General";
import { getters, actions } from "../model";
import { TAB_IDS, TASK_TYPES } from "../constants";

import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";
import CSSModules from "react-css-modules";
import styles from "./styles.scss";

import { useMobile } from "Portal/NewPortal/Shared/UseMobile";
import Tooltip from "ui-kit/Tooltip";

const STATUSES = {
  COMPLETE: "complete",
  APPROVED: "approved"
};

const decorate = R.compose(
  CSSModules,
  connect(
    state => ({
      selectedTab: getters.selectedTab(state),
      taskData: getters.taskData(state),
      fileUploadData: getters.fileUploadData(state),
      fileUploadUploadHasFinished: getters.fileUploadUploadHasFinished(state),
      record: getters.record(state),
      file: getters.fileUploadData(state),
      backgroundColor: getBackgroundColor(state),
      loadingSavingFile: getters.loadingSavingFile(state),
      taskSessionId: getters.taskSessionId(state)
    }),
    {
      // openSession: actions.openSession
      executeAction: actions.executeAction,
      saveFileUpload: actions.saveFileUpload
    }
  )
);

const Footer = ({
  executeAction = noop,
  selectedTab,
  taskData = {},
  fileUploadData = {},
  fileUploadUploadHasFinished = false,
  hideModal = noop,
  saveFileUpload = noop,
  record = {},
  file = {},
  backgroundColor = null,
  loadingSavingFile = false,
  taskSessionId
}) => {
  const {
    // id = null,
    open_label,
    // due_label,
    type = null,
    meta = {},
    status = undefined
  } = taskData || {};

  const isClosed = open_label === "Closed";

  // const metaUrl = R.path(["meta", "url"], taskData);
  // const getIncludesAgo = () => {
  //   if (!due_label || !R.is(String, due_label)) return null;
  //   return due_label.includes("ago") ? "Closed" : "Open";
  // };
  // const formattedOpenLabel = open_label || getIncludesAgo();

  // const hasCompletionMethod =
  //   R.propEq("completionMethod", "manual")(meta) ||
  //   R.propEq("completionMethod", "click")(meta);

  // const showRightContainer =
  //   formattedOpenLabel ||
  //   due_label ||
  //   R.propEq("completionMethod", "manual")(meta) ||
  //   (R.propEq("completionMethod", "click")(meta) &&
  //     metaUrl &&
  //     status === STATUSES.COMPLETE);

  // const isOnClickAndCompleted =
  //   R.propEq("completionMethod", "click")(meta) && status === STATUSES.COMPLETE;

  const isMobile = useMobile();
  const markTaskAsViewOnly =
    selectedTab === TAB_IDS.DETAILS &&
    [STATUSES.COMPLETE, STATUSES.APPROVED].includes(status) &&
    Boolean(meta.markCompletedAsViewOnly)
      ? true
      : false;

  const getTaskButton = () => {
    return (
      <>
        {selectedTab === TAB_IDS.DETAILS &&
        type === TASK_TYPES.ASSIGNED_TASK ? (
          <MediumFilledButton
            tooltipPlacement="top"
            tooltip={
              isClosed
                ? "This task is closed and cannot be modified"
                : markTaskAsViewOnly
                ? "This task has already been completed and is read-only"
                : null
            }
            disabled={isClosed || markTaskAsViewOnly}
            bg="#4263EB"
            onClick={() => {
              executeAction({ type: TASK_TYPES.TOGGLE_TASK, data: taskData });
            }}
            style={{
              height: "38px",
              width: isMobile ? "100%" : "169px",
              fontSize: "14px",
              borderRadius: "6px"
            }}
            className="accentable-primary-button"
          >
            {status !== STATUSES.COMPLETE
              ? "Mark as Complete"
              : "Mark as Incomplete"}
          </MediumFilledButton>
        ) : null}

        {selectedTab === TAB_IDS.DETAILS &&
        type === TASK_TYPES.DOCUMENT_REQUEST ? (
          <MediumFilledButton
            tooltipPlacement="top"
            tooltip={
              isClosed
                ? "This task is closed and cannot be modified"
                : markTaskAsViewOnly
                ? "This task has already been completed and is read-only"
                : null
            }
            disabled={
              (fileUploadData && !fileUploadUploadHasFinished) ||
              isEmptyOrNil(fileUploadData)
                ? true
                : markTaskAsViewOnly
            }
            className="accentable-primary-button"
            onClick={() => {
              if (
                (fileUploadData && !fileUploadUploadHasFinished) ||
                isEmptyOrNil(fileUploadData)
              ) {
                noop();
              } else {
                saveFileUpload({ file, record, taskData, taskSessionId });
              }
            }}
            style={{
              height: "38px",
              width: isMobile ? "100%" : "169px",
              fontSize: "14px",
              borderRadius: "6px",
              cursor: "pointer"
            }}
          >
            {loadingSavingFile && (
              <div style={{ display: "flex", gap: "8px" }}>
                <LoadingIcon color="white" size={18} /> Submitting...
              </div>
            )}
            {!loadingSavingFile && "Submit"}
          </MediumFilledButton>
        ) : null}
      </>
    );
  };

  return (
    <div
      style={{
        ...(backgroundColor ? { backgroundColor } : {})
      }}
      className={styles.footer}
    >
      {selectedTab === TAB_IDS.DETAILS && (
        <MediumOutlineButton
          bg="white"
          color="neutral7"
          bc="neutral2"
          onClick={hideModal}
          style={{
            borderWidth: "1px",
            height: "38px",
            width: isMobile ? "100%" : "76px",
            fontSize: "14px",
            borderRadius: "6px"
          }}
        >
          {type === TASK_TYPES.DOCUMENT_REQUEST &&
          fileUploadData &&
          Object.keys(fileUploadData).length
            ? "Cancel"
            : "Done"}
        </MediumOutlineButton>
      )}
      {markTaskAsViewOnly ? (
        <>
          <Tooltip
            placement="top"
            tooltip="This task has already been completed and is read-only"
          >
            {getTaskButton()}
          </Tooltip>
        </>
      ) : (
        getTaskButton()
      )}
    </div>
  );
};
export default decorate(Footer);
